/* WESN - Free Forsta campaign (Theme settings > Free Forsta campaign).
   One cart-state engine shared by the sticky gift bar, the product-page callout, the collection badges,
   the kit / quick-add buttons, the exit-intent modal and, in "campaign cart drawer" mode, the theme's own
   cart drawer (snippets/forsta-cart-drawer.liquid). The cart is read from /cart.js and every
   [data-forsta-progress] widget is kept in step. Settings arrive in window.forstaCampaign
   (snippets/forsta-config.liquid).

   Two modes:
   - cart.enabled = false: the cart drawer is UpCart; UpCart adds and zeroes the gift, this file only reads.
   - cart.enabled = true:  the theme drawer replaces UpCart. This file adds the gift (the shopper's color)
     when the qualifying subtotal crosses the threshold, removes it when it drops below, swaps the color on
     request and applies the gift discount code so the line is free. The subtotal counts every line except
     the gift product itself, mirroring the discount's buy-set (the "qualifying products" collection). */
(function () {
  'use strict';

  var cfg = window.forstaCampaign;
  if (!cfg || !cfg.enabled || !cfg.gift) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var rate = 1;
  try { rate = parseFloat(window.Shopify.currency.rate) || 1; } catch (e) { rate = 1; }
  var threshold = Math.round(cfg.threshold * rate); /* cents, in the cart's currency */
  var giftValue = Math.round(cfg.value * rate);
  var text = cfg.text || {};
  var cartCfg = cfg.cart || {};
  var cartMode = !!cartCfg.enabled;
  var discountCode = String(cartCfg.code || '').trim();
  var shippingThreshold = cartCfg.shippingThreshold ? Math.round(cartCfg.shippingThreshold * rate) : 0;
  var cartText = cartCfg.text || {};
  var GIFT_PROP = '_forsta_gift';
  var STORE_VARIANT = 'forstaGiftVariant';
  var STORE_DECLINED = 'forstaGiftDeclined';

  /* ---------- helpers ---------- */
  /* Money is formatted here rather than through the theme's Shopify.formatMoney, which only knows four of
     Shopify's placeholders and returns an empty amount for the others (the store's SEK format is
     "{{amount_with_space_separator}} kr", which left every JS-rendered price as " kr"). The shop's format may
     also contain HTML (the US store wraps amounts in <span class=money>); every caller writes the result into
     textContent or a template string, so the tags are stripped. */
  function money(cents) {
    var format = cfg.moneyFormat || '{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var m = format.match(placeholder);
    var n = Number(cents);
    if (isNaN(n)) n = 0;
    function num(precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var value;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = num(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = num(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = num(2, "'", '.'); break;
      case 'amount_no_decimals_with_apostrophe_separator': value = num(0, "'", '.'); break;
      case 'amount_with_space_separator': value = num(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = num(0, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = num(2, ' ', '.'); break;
      default: value = num(2, ',', '.');
    }
    return (m ? format.replace(placeholder, value) : value).replace(/<[^>]*>/g, '');
  }
  function moneyShort(cents) { return money(cents).replace(/([.,])00(?!\d)/, ''); }
  function fill(template, map) {
    return String(template || '').replace(/\[(\w+)\]/g, function (m, key) { return map.hasOwnProperty(key) ? map[key] : m; });
  }
  function setText(scope, selector, value) {
    var els = scope.querySelectorAll(selector);
    for (var i = 0; i < els.length; i++) if (els[i].textContent !== String(value)) els[i].textContent = value;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function imgUrl(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
  }
  function storeGet(storage, key) { try { return window[storage].getItem(key); } catch (e) { return null; } }
  function storeSet(storage, key, value) { try { window[storage].setItem(key, value); } catch (e) { /* blocked */ } }
  function storeRemove(storage, key) { try { window[storage].removeItem(key); } catch (e) { /* blocked */ } }
  function warn() { if (window.console && console.warn) console.warn.apply(console, ['[forsta]'].concat([].slice.call(arguments))); }

  /* ---------- cart state ---------- */
  var state = {
    items: 0, subtotal: 0, gap: threshold, unlocked: false,
    giftInCart: false, giftLine: null, giftLines: [], giftFree: false, codeApplied: false,
    declined: storeGet('sessionStorage', STORE_DECLINED) === '1', cart: null
  };
  var subscribers = [];
  var lastGiftKey = null, ourRemoval = false;

  /* UpCart tags its reward line with __upcartRewardProduct; the theme tags its gift line with _forsta_gift;
     a zeroed line of the gift product counts too. */
  function isGiftLine(item) {
    var props = item.properties || {};
    if (props[GIFT_PROP]) return true;
    if (props.__upcartRewardProduct || props.__upcartTier !== undefined) return true;
    return item.product_id === cfg.gift.id && item.final_line_price === 0;
  }
  /* In drawer mode the gift product never counts (paid or not), exactly like the discount's buy-set. */
  function countsTowardThreshold(item) {
    if (cartMode) return item.product_id !== cfg.gift.id;
    return !isGiftLine(item);
  }

  function compute(cart) {
    var subtotal = 0, count = 0;
    var items = cart.items || [];
    var giftLines = items.filter(isGiftLine);
    var giftLine = giftLines[0] || null;
    items.forEach(function (item) {
      if (isGiftLine(item)) return;
      count += item.quantity;
      if (countsTowardThreshold(item)) subtotal += item.final_line_price;
    });
    var unlocked = subtotal >= threshold;
    if (cartMode) {
      if (unlocked && !giftLine && lastGiftKey && !ourRemoval) {
        state.declined = true;
        storeSet('sessionStorage', STORE_DECLINED, '1');
      }
      if (!unlocked && state.declined) {
        state.declined = false;
        storeRemove('sessionStorage', STORE_DECLINED);
      }
      ourRemoval = false;
      lastGiftKey = giftLine ? giftLine.key : null;
    }
    state.cart = cart;
    state.items = count;
    state.subtotal = subtotal;
    state.gap = Math.max(0, threshold - subtotal);
    state.unlocked = unlocked;
    state.giftLines = giftLines;
    state.giftLine = giftLine;
    state.giftInCart = !!giftLine;
    state.giftFree = !!giftLine && giftLine.final_line_price === 0;
    state.codeApplied = !!discountCode && (cart.discount_codes || []).some(function (d) {
      return d && String(d.code || '').toUpperCase() === discountCode.toUpperCase() && d.applicable !== false;
    });
    render();
    subscribers.forEach(function (fn) { try { fn(state); } catch (e) { warn(e); } });
    if (cartMode) reconcile();
  }

  var pending = null, dirty = false;
  function refresh() {
    if (pending) { dirty = true; return pending; }
    pending = window.fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(compute)
      .catch(function (e) { warn('cart.js failed', e); })
      .then(function () {
        pending = null;
        if (dirty) { dirty = false; refresh(); }
      });
    return pending;
  }

  /* ---------- cart requests (internal ones never pop the drawer open) ---------- */
  var internal = 0;
  function cartRequest(path, body) {
    internal++;
    return window.fetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error((j && (j.description || j.message)) || ('Cart request failed (' + r.status + ')'));
        return j;
      });
    }).then(function (j) { internal--; return j; }, function (e) { internal--; throw e; });
  }

  /* ---------- gift reconciliation (drawer mode) ---------- */
  var busy = false, codeTriedAt = -1, addFailedAt = -1;

  function availableVariant(id) {
    var list = cfg.gift.variants || [];
    for (var i = 0; i < list.length; i++) if (list[i].id === id && list[i].available) return list[i].id;
    return null;
  }
  function preferredVariant() {
    var stored = Number(storeGet('localStorage', STORE_VARIANT));
    return availableVariant(stored) || availableVariant(Number(cartCfg.defaultVariant)) ||
      ((cfg.gift.variants || []).filter(function (v) { return v.available; })[0] || {}).id || null;
  }
  function addGift(variantId) {
    if (!variantId) return Promise.reject(new Error('No available gift variant'));
    var items = [{ id: variantId, quantity: 1, properties: {} }];
    items[0].properties[GIFT_PROP] = 'yes';
    return cartRequest('cart/add.js', { items: items }).then(function () {
      if (discountCode) return applyCode();
    });
  }
  function applyCode() {
    if (!discountCode) return Promise.resolve();
    return cartRequest('cart/update.js', { discount: discountCode }).then(function (cart) {
      if (cart && cart.items) compute(cart);
    });
  }
  function removeLines(lines) {
    return lines.reduce(function (p, line) {
      return p.then(function () { return cartRequest('cart/change.js', { id: line.key, quantity: 0 }); });
    }, Promise.resolve());
  }
  function setBusy(value) {
    busy = value;
    if (!drawer) return;
    drawer.classList.toggle('is-busy', value);
    var checkout = drawer.querySelector('.forsta-cart__checkout-button');
    if (checkout) checkout.disabled = value;
  }
  function run(promise) {
    setBusy(true);
    return promise
      .catch(function (e) { warn(e && e.message ? e.message : e); })
      .then(function () { setBusy(false); return refresh(); });
  }
  function reconcile() {
    if (!cartMode || busy || !state.cart) return;
    var s = state;
    if (s.unlocked) {
      if (!s.giftLine) {
        if (s.declined || addFailedAt === s.subtotal) return;
        var variant = preferredVariant();
        if (!variant) { addFailedAt = s.subtotal; return; }
        run(addGift(variant).catch(function (e) { addFailedAt = s.subtotal; throw e; }));
      } else if (s.giftLines.length > 1) {
        run(removeLines(s.giftLines.slice(1)));
      } else if (!s.giftFree && discountCode && !s.codeApplied && codeTriedAt !== s.subtotal) {
        codeTriedAt = s.subtotal;
        run(applyCode());
      }
    } else if (s.giftLines.length) {
      ourRemoval = true;
      run(removeLines(s.giftLines));
    }
  }
  function swapGift(variantId, chip) {
    if (!cartMode || busy || !state.giftLine || state.giftLine.variant_id === variantId) return;
    if (!availableVariant(variantId)) return;
    storeSet('localStorage', STORE_VARIANT, String(variantId));
    if (chip) chip.classList.add('is-loading');
    ourRemoval = true;
    run(removeLines([state.giftLine]).then(function () { return addGift(variantId); }))
      .then(function () { if (chip) chip.classList.remove('is-loading'); });
  }
  function changeLine(key, quantity) {
    var row = drawer && drawer.querySelector('.forsta-cart__line[data-key="' + key.replace(/"/g, '\\"') + '"]');
    if (row) row.classList.add('is-busy');
    return cartRequest('cart/change.js', { id: key, quantity: quantity })
      .then(function (cart) { if (cart && cart.items) compute(cart); })
      .catch(function (e) { warn(e.message); refresh(); })
      .then(function () { if (row) row.classList.remove('is-busy'); });
  }

  /* ---------- rendering ---------- */
  var header = null, barEl = null, drawer = null;

  function render() {
    var pct = threshold > 0 ? Math.min(100, Math.round(state.subtotal / threshold * 100)) : 100;
    /* UI states: locked (under the threshold), pending (over it, gift not in the cart or not free yet),
       declined (over it, the shopper removed the gift), unlocked (gift in the cart at €0). Outside drawer
       mode UpCart owns the gift, so "unlocked" simply means over the threshold. */
    var declinedUi = cartMode && state.unlocked && state.declined && !state.giftLine;
    var unlockedUi = state.unlocked && (!cartMode || state.giftFree);
    var pendingUi = cartMode && state.unlocked && !state.giftFree && !declinedUi;
    var widgets = document.querySelectorAll('[data-forsta-progress]');
    for (var i = 0; i < widgets.length; i++) {
      var el = widgets[i];
      el.classList.toggle('is-unlocked', unlockedUi);
      el.classList.toggle('is-pending', pendingUi);
      el.classList.toggle('is-declined', declinedUi);
      el.classList.toggle('is-locked', !state.unlocked);
      el.classList.toggle('is-empty', state.items === 0);
      var bar = el.querySelector('[data-forsta-progressbar]');
      if (bar) {
        bar.setAttribute('aria-valuenow', pct);
        var fillEl = bar.querySelector('.forsta-progress__fill');
        if (fillEl) fillEl.style.width = pct + '%';
      }
      setText(el, '[data-forsta-gap]', money(state.gap));
      setText(el, '[data-forsta-subtotal]', moneyShort(state.subtotal));
      setText(el, '[data-forsta-threshold]', moneyShort(threshold));
      setText(el, '[data-forsta-count]', state.items);
    }
    if (barEl) {
      var show = state.items > 0;
      barEl.hidden = !show;
      document.documentElement.classList.toggle('forsta-bar-visible', show);
      positionBar();
      padMain();
    }
    if (drawer) renderCart();
    var counter = document.getElementById('cart-counter');
    if (counter && state.cart) {
      counter.innerHTML = '<span>' + state.cart.item_count + '</span>';
      counter.classList.toggle('empty', state.cart.item_count < 1);
    }
  }

  function lineHtml(item) {
    var variant = item.product_has_only_default_variant ? '' : (item.variant_title || '');
    var props = '';
    var p = item.properties || {};
    for (var k in p) {
      if (p.hasOwnProperty(k) && k.charAt(0) !== '_' && p[k]) props += '<span class="forsta-cart__line-prop">' + esc(k) + ': ' + esc(p[k]) + '</span>';
    }
    var price = item.final_line_price < item.original_line_price
      ? '<s>' + esc(money(item.original_line_price)) + '</s>' + esc(money(item.final_line_price))
      : esc(money(item.final_line_price));
    var key = esc(item.key);
    return '<div class="forsta-cart__line" data-key="' + key + '">' +
      '<a class="forsta-cart__line-media" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(imgUrl(item.image, 240)) + '" alt="" loading="lazy" width="84" height="84"></a>' +
      '<div class="forsta-cart__line-body">' +
        '<a class="forsta-cart__line-title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
        (variant ? '<span class="forsta-cart__line-variant">' + esc(variant) + '</span>' : '') + props +
        '<div class="forsta-cart__line-actions">' +
          '<div class="forsta-cart__qty" role="group" aria-label="' + esc(cartText.quantity || 'Quantity') + '">' +
            '<button type="button" data-forsta-qty="-1" data-key="' + key + '" aria-label="' + esc(cartText.decrease || 'Less') + '">-</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-forsta-qty="1" data-key="' + key + '" aria-label="' + esc(cartText.increase || 'More') + '">+</button>' +
          '</div>' +
          '<button type="button" class="forsta-cart__remove" data-forsta-remove data-key="' + key + '">' + esc(cartText.remove || 'Remove') + '</button>' +
        '</div>' +
      '</div>' +
      '<span class="forsta-cart__line-price">' + price + '</span>' +
    '</div>';
  }

  function renderCart() {
    var cart = state.cart;
    if (!cart) return;
    var count = state.items;
    setText(drawer, '[data-forsta-cart-count]', count === 1 ? (cartText.itemOne || '1 item') : fill(cartText.itemMany || '[count] items', { count: count }));
    var empty = cart.item_count === 0;
    var emptyEl = drawer.querySelector('[data-forsta-cart-empty]');
    if (emptyEl) emptyEl.hidden = !empty;
    drawer.classList.toggle('is-empty', empty);

    /* gift line */
    var giftEl = drawer.querySelector('[data-forsta-gift-line]');
    var giftRow = drawer.querySelector('[data-forsta-gift-row]');
    var g = state.giftLine;
    if (giftEl) {
      giftEl.hidden = !g;
      if (g) {
        var img = giftEl.querySelector('[data-forsta-gift-image]');
        if (img && img.getAttribute('data-src') !== g.image) { img.setAttribute('data-src', g.image); img.src = imgUrl(g.image, 240); }
        setText(giftEl, '[data-forsta-gift-price]', money(g.final_line_price));
        setText(giftEl, '[data-forsta-gift-compare]', g.final_line_price < g.original_line_price ? money(g.original_line_price) : '');
        var warnEl = giftEl.querySelector('[data-forsta-gift-warning]');
        if (warnEl) warnEl.hidden = state.giftFree;
        var chips = giftEl.querySelectorAll('[data-forsta-gift-variant]');
        for (var i = 0; i < chips.length; i++) {
          var on = Number(chips[i].getAttribute('data-forsta-gift-variant')) === g.variant_id;
          chips[i].setAttribute('aria-checked', on ? 'true' : 'false');
        }
      }
    }
    if (giftRow) {
      var saving = g ? g.original_line_price - g.final_line_price : 0;
      giftRow.hidden = !(g && saving > 0);
      if (g) {
        setText(giftRow, '[data-forsta-gift-color]', g.variant_title || '');
        setText(giftRow, '[data-forsta-gift-saving]', money(saving));
      }
    }
    var readd = drawer.querySelector('[data-forsta-gift-readd]');
    if (readd) readd.hidden = !(cartMode && state.unlocked && state.declined && !g);

    /* line items (everything but the gift) */
    var linesEl = drawer.querySelector('[data-forsta-cart-lines]');
    if (linesEl) {
      var html = (cart.items || []).filter(function (it) { return !isGiftLine(it); }).map(lineHtml).join('');
      if (linesEl.getAttribute('data-rendered') !== html) {
        /* keep keyboard focus on the same control across a re-render */
        var active = document.activeElement, restore = null;
        if (active && linesEl.contains(active) && active.getAttribute('data-key')) {
          restore = { key: active.getAttribute('data-key'), qty: active.getAttribute('data-forsta-qty'), remove: active.hasAttribute('data-forsta-remove') };
        }
        linesEl.innerHTML = html;
        linesEl.setAttribute('data-rendered', html);
        if (restore) {
          var keySel = '[data-key="' + restore.key.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]';
          var again = linesEl.querySelector((restore.remove ? '[data-forsta-remove]' : '[data-forsta-qty="' + restore.qty + '"]') + keySel) ||
            linesEl.querySelector('.forsta-cart__line' + keySel + ' button') || linesEl.querySelector('button');
          if (again) again.focus();
        }
      }
    }
    var checkout = drawer.querySelector('.forsta-cart__checkout-button');
    if (checkout) checkout.disabled = busy;

    /* shipping + totals */
    var ship = drawer.querySelector('[data-forsta-shipping]');
    if (ship) {
      if (!shippingThreshold) { ship.textContent = ''; ship.classList.remove('is-unlocked'); }
      else {
        var paid = cart.total_price;
        var ok = paid >= shippingThreshold;
        ship.textContent = ok ? (cartText.shippingUnlocked || '') : fill(cartText.shippingGap || '', { amount: moneyShort(shippingThreshold - paid) });
        ship.classList.toggle('is-unlocked', ok);
      }
    }
    setText(drawer, '[data-forsta-cart-total]', money(cart.total_price));
  }

  /* ---------- drawer open / close (theme .drawer mechanics) ---------- */
  var lastFocus = null, addedTimer = null;
  function openDrawer(added) {
    if (!drawer) return;
    var body = document.body;
    var addedEl = drawer.querySelector('[data-forsta-cart-added]');
    if (addedEl && added) {
      addedEl.hidden = false;
      clearTimeout(addedTimer);
      addedTimer = setTimeout(function () { addedEl.hidden = true; }, 4000);
    } else if (addedEl && !added) {
      addedEl.hidden = true;
    }
    refresh();
    if (body.classList.contains('drawer-cart-open')) return;
    lastFocus = document.activeElement;
    var show = function () {
      drawer.setAttribute('aria-hidden', 'false');
      body.classList.add('drawer-open', 'drawer-cart-open');
      setTimeout(function () { body.classList.add('mask-visible'); }, 125);
      setTimeout(function () {
        var close = drawer.querySelector('[data-forsta-cart-close]');
        if (close) close.focus();
      }, 300);
    };
    if (body.classList.contains('drawer-open') && typeof window.closeDrawers === 'function') window.closeDrawers(show);
    else show();
  }
  function closeDrawer() {
    var body = document.body;
    if (!body.classList.contains('drawer-cart-open')) return;
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
    if (typeof window.closeDrawers === 'function') window.closeDrawers(function () { /* done */ });
    else body.classList.remove('drawer-open', 'drawer-cart-open', 'mask-visible');
    if (lastFocus && lastFocus.focus && drawer && !drawer.contains(lastFocus)) { try { lastFocus.focus(); } catch (e) { /* noop */ } }
    lastFocus = null;
  }
  function openCart(added) {
    if (cartMode && drawer) { openDrawer(!!added); return; }
    if (typeof window.upcartOpenCart === 'function') { try { window.upcartOpenCart(); return; } catch (e) { /* fall through */ } }
    window.location.href = root + 'cart';
  }

  /* The bar is fixed right under the sticky header and follows it when the header slides away on scroll. */
  var ticking = false;
  function positionBar() {
    if (!barEl || barEl.hidden) return;
    var top = 0;
    if (header) top = Math.max(0, header.getBoundingClientRect().bottom);
    barEl.style.top = top + 'px';
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () { positionBar(); ticking = false; });
  }
  /* Pages whose first section is pulled up behind the header (heroes) keep their layout; everything else
     gets the bar's height as top padding so nothing is covered. */
  function padMain() {
    var main = document.querySelector('main');
    if (!main || !barEl) return;
    if (barEl.hidden) { main.style.paddingTop = ''; return; }
    var wrapper = main.firstElementChild;
    var section = wrapper && wrapper.firstElementChild;
    var pulled = false;
    [wrapper, section].forEach(function (el) {
      if (el && parseFloat(window.getComputedStyle(el).marginTop) < 0) pulled = true;
    });
    main.style.paddingTop = pulled ? '' : barEl.offsetHeight + 'px';
  }

  /* ---------- shopper-triggered adds (quick adds, kits, PDP "add both") ---------- */
  function addItems(items) {
    return window.fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
      return r.json();
    }).then(function (res) { afterAdd(); return res; });
  }
  function afterAdd() {
    if (typeof window.displayCartCount === 'function') { try { window.displayCartCount(); } catch (e) { /* noop */ } }
    if (!cartMode && typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) { /* noop */ } }
    openCart(true);
    refresh();
  }

  document.addEventListener('click', function (e) {
    var cartLink = cartMode && drawer ? e.target.closest('.menu-tools__item--cart a, a[href$="/cart"][aria-controls="CartDrawer"]') : null;
    if (cartLink) { e.preventDefault(); openDrawer(false); return; }
    if (drawer && e.target.closest('[data-forsta-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (drawer && e.target.closest('.drawer-mask') && document.body.classList.contains('drawer-cart-open')) { closeDrawer(); return; }

    var btn = e.target.closest('[data-forsta-add], [data-forsta-kit], [data-forsta-open-cart], [data-forsta-gift-variant], [data-forsta-qty], [data-forsta-remove], [data-forsta-gift-readd]');
    if (!btn) return;

    if (btn.hasAttribute('data-forsta-open-cart')) { e.preventDefault(); openCart(false); return; }
    if (btn.hasAttribute('data-forsta-gift-variant')) { e.preventDefault(); swapGift(Number(btn.getAttribute('data-forsta-gift-variant')), btn); return; }
    if (btn.hasAttribute('data-forsta-qty')) {
      e.preventDefault();
      var key = btn.getAttribute('data-key');
      var item = (state.cart && state.cart.items || []).filter(function (it) { return it.key === key; })[0];
      if (item) changeLine(key, Math.max(0, item.quantity + Number(btn.getAttribute('data-forsta-qty'))));
      return;
    }
    if (btn.hasAttribute('data-forsta-remove')) { e.preventDefault(); changeLine(btn.getAttribute('data-key'), 0); return; }
    if (btn.hasAttribute('data-forsta-gift-readd')) {
      e.preventDefault();
      state.declined = false;
      storeRemove('sessionStorage', STORE_DECLINED);
      reconcile();
      return;
    }

    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    var ids = (btn.getAttribute('data-forsta-add') || btn.getAttribute('data-forsta-kit') || '').split(',').filter(Boolean);
    if (!ids.length) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    addItems(ids.map(function (id) { return { id: Number(id), quantity: 1 }; }))
      .then(function () {
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 2500);
      })
      .catch(function (err) {
        btn.classList.add('is-error');
        btn.setAttribute('title', err.message);
        setTimeout(function () { btn.classList.remove('is-error'); }, 3000);
      })
      .then(function () { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && document.body.classList.contains('drawer-cart-open')) closeDrawer();
  });

  /* ---------- collection badges in a non-EUR currency ---------- */
  function fixBadges() {
    if (rate === 1) return;
    var badges = document.querySelectorAll('[data-forsta-badge="gap"], [data-forsta-badge="included"]');
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      var price = Number(b.getAttribute('data-forsta-price')) || 0;
      var gap = threshold - price;
      var span = b.querySelector('span');
      if (!span) continue;
      if (gap <= 0) {
        span.textContent = text.badgeIncluded || span.textContent;
        b.classList.remove('product-badges__badge--forsta-gap');
        b.classList.add('product-badges__badge--forsta-included');
      } else {
        span.textContent = fill(text.badgeGap, { amount: moneyShort(gap) });
        b.classList.remove('product-badges__badge--forsta-included');
        b.classList.add('product-badges__badge--forsta-gap');
      }
    }
  }

  /* ---------- product page: callout + "add both" ---------- */
  function initPdp() {
    var box = document.querySelector('[data-forsta-callout]');
    var form = document.querySelector('.product-form-main');
    if (!box || !form) return;
    var toggle = box.querySelector('[data-forsta-addon-toggle]');
    var addonPrice = toggle ? Number(toggle.getAttribute('data-forsta-addon-price')) || 0 : 0;
    var textEl = box.querySelector('[data-forsta-pdp-text]');
    var summary = box.querySelector('[data-forsta-summary]');
    var note = box.querySelector('[data-forsta-addon-note]');

    function currentPrice() {
      var sel = form.querySelector('select[name="id"]');
      if (sel && sel.selectedIndex >= 0) {
        var o = sel.options[sel.selectedIndex];
        if (o && o.dataset.price) return Number(o.dataset.price);
      }
      return Number(box.getAttribute('data-forsta-price')) || 0;
    }
    function update() {
      var price = currentPrice();
      var gap = threshold - price;
      box.classList.toggle('is-over', gap <= 0);
      if (textEl) {
        textEl.textContent = gap <= 0
          ? textEl.getAttribute('data-text-over')
          : fill(textEl.getAttribute('data-text-gap'), { amount: money(gap), threshold: moneyShort(threshold) });
      }
      if (summary && toggle) {
        var both = price + addonPrice;
        /* only claim the gift is included when product + add-on actually reach the threshold */
        var covers = gap <= 0 || addonPrice >= gap;
        var tpl = covers ? summary.getAttribute('data-template')
                         : (summary.getAttribute('data-template-short') || summary.getAttribute('data-template'));
        summary.innerHTML = fill(tpl, {
          both: money(both), full: money(both + giftValue), value: moneyShort(giftValue), zero: money(0),
          left: money(Math.max(0, gap - addonPrice))
        });
      }
      if (note) note.hidden = !(gap > 0 && addonPrice >= gap);
      updateLabels();
    }
    function updateLabels() {
      var on = !!(toggle && toggle.checked && !box.classList.contains('is-over'));
      var buttons = document.querySelectorAll('.product-form-main .button--add-to-cart, .sticky-button .button--add-to-cart');
      for (var i = 0; i < buttons.length; i++) {
        var btn = buttons[i], label = btn.querySelector('.button-label');
        if (!label) continue;
        var usable = !btn.disabled && !btn.classList.contains('inactive');
        if (on && usable) {
          if (!label.dataset.forstaOrig) label.dataset.forstaOrig = label.textContent;
          label.textContent = text.pdpButton || label.textContent;
        } else if (label.dataset.forstaOrig && label.textContent === text.pdpButton) {
          label.textContent = window.label_add_to_cart || label.dataset.forstaOrig;
        }
      }
    }
    if (toggle) toggle.addEventListener('change', updateLabels);
    form.addEventListener('change', function () { setTimeout(update, 60); });
    setInterval(updateLabels, 1500);

    /* Add both: the theme's own click handler adds one item, so we step in first (capture phase on the form). */
    form.addEventListener('click', function (e) {
      var btn = e.target.closest('.button--add-to-cart');
      if (!btn || !toggle || !toggle.checked || box.classList.contains('is-over')) return;
      if (btn.disabled || btn.classList.contains('inactive')) return;
      var id = null;
      var sel = form.querySelector('select[name="id"]');
      if (sel) {
        var o = sel.options[sel.selectedIndex];
        if (!o || o.dataset.available !== 'true') return;
        id = Number(o.value);
      } else {
        var hidden = form.querySelector('input[name="id"]');
        if (!hidden) return;
        id = Number(hidden.value);
      }
      if (!id) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var items = [{ id: id, quantity: 1 }];
      var companions = document.querySelectorAll('.companion-product .companion-variant.active');
      for (var i = 0; i < companions.length; i++) {
        if (companions[i].dataset.id) items.push({ id: Number(companions[i].dataset.id), quantity: 1, properties: { _companion_product: 'yes' } });
      }
      items.push({ id: Number(toggle.getAttribute('data-forsta-addon-variant')), quantity: 1 });
      btn.classList.add('is-loading');
      addItems(items)
        .catch(function (err) { warn('add both failed:', err.message); })
        .then(function () { btn.classList.remove('is-loading'); });
    }, true);

    update();
  }

  /* ---------- exit-intent modal (desktop, once per session, cart 1-99 short of the gift) ---------- */
  function pickAddon(gap) {
    var list = (cfg.addons || []).filter(function (a) { return a && a.id; });
    var covering = list.filter(function (a) { return a.price >= gap; }).sort(function (a, b) { return a.price - b.price; });
    if (covering.length) return covering[0];
    return list.sort(function (a, b) { return b.price - a.price; })[0] || null;
  }
  function initExit() {
    var modal = document.querySelector('[data-forsta-exit]');
    if (!modal) return;
    if (!window.matchMedia('(min-width: 1025px) and (hover: hover)').matches) return;
    var KEY = 'forstaExitShown';
    if (storeGet('sessionStorage', KEY)) return;
    var armed = false, shown = false;
    setTimeout(function () { armed = true; }, 4000);

    function eligible() {
      return state.items > 0 && !state.unlocked && state.gap >= 100 && state.gap < threshold;
    }
    function show() {
      shown = true;
      storeSet('sessionStorage', KEY, '1');
      var pick = pickAddon(state.gap);
      setText(modal, '[data-forsta-exit-title]', fill(text.exitTitle, { amount: money(state.gap) }));
      setText(modal, '[data-forsta-exit-text]', fill(text.exitText, {
        subtotal: moneyShort(state.subtotal),
        min: moneyShort(pick ? Math.min(pick.price, state.gap) : state.gap),
        value: moneyShort(giftValue),
        threshold: moneyShort(threshold)
      }));
      var btn = modal.querySelector('[data-forsta-exit-add]');
      if (btn) {
        if (pick) {
          btn.hidden = false;
          btn.setAttribute('data-forsta-add', pick.id);
          setText(btn, '[data-forsta-exit-label]', fill(text.exitButton, { product: pick.title, price: moneyShort(pick.price) }));
          var img = btn.querySelector('img');
          if (img && pick.image) { img.src = pick.image; img.alt = pick.title; }
        } else {
          btn.hidden = true;
        }
      }
      modal.hidden = false;
      document.documentElement.classList.add('forsta-exit-open');
      render();
      var close = modal.querySelector('[data-forsta-exit-close]');
      if (close) close.focus();
    }
    function hide() {
      modal.hidden = true;
      document.documentElement.classList.remove('forsta-exit-open');
    }
    document.addEventListener('mouseout', function (e) {
      if (!armed || shown || e.relatedTarget || e.clientY > 0) return;
      if (document.body.classList.contains('drawer-cart-open')) return;
      if (!eligible()) return;
      show();
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-forsta-exit-close]')) { e.preventDefault(); hide(); return; }
      if (e.target.closest('[data-forsta-exit-add], [data-forsta-open-cart]')) setTimeout(hide, 300);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) hide(); });
    subscribers.push(function (s) { if (!modal.hidden && s.unlocked) hide(); });
  }

  /* ---------- keep in step with the theme, apps and UpCart ---------- */
  function hookCartRequests() {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var wasInternal = internal > 0;
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        p.then(function (r) {
          if (cartMode && !wasInternal && r && r.ok && /\/cart\/add/.test(url)) openCart(true);
          setTimeout(refresh, 80);
        }, function () { /* noop */ });
      }
      return p;
    };
    var origOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (/\/cart\/(add|change|update|clear)/.test(String(url))) {
          var isAdd = /\/cart\/add/.test(String(url));
          this.addEventListener('loadend', function () {
            if (cartMode && isAdd && this.status >= 200 && this.status < 300) openCart(true);
            setTimeout(refresh, 80);
          });
        }
      } catch (e) { /* noop */ }
      return origOpen.apply(this, arguments);
    };
  }
  function hookUpcart() {
    if (cartMode) return;
    var tries = 0;
    (function subscribe() {
      var names = ['upcartSubscribeCartUpdated', 'upcartSubscribeAddedToCart', 'upcartSubscribeItemRemoved', 'upcartSubscribeCartLoaded'];
      if (typeof window[names[0]] === 'function') {
        names.forEach(function (n) {
          if (typeof window[n] === 'function') { try { window[n](function () { setTimeout(refresh, 80); }); } catch (e) { /* noop */ } }
        });
        return;
      }
      if (++tries < 60) setTimeout(subscribe, 250);
    })();
  }

  function init() {
    header = document.querySelector('.section-header');
    barEl = document.querySelector('[data-forsta-bar]');
    drawer = cartMode ? document.querySelector('[data-forsta-cart]') : null;
    hookCartRequests();
    hookUpcart();
    fixBadges();
    initPdp();
    initExit();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { positionBar(); padMain(); });
    if (header) header.addEventListener('transitionend', positionBar);
    refresh();
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }

  window.forstaCampaign.refresh = refresh;
  window.forstaCampaign.state = state;
  window.forstaCampaign.subscribe = function (fn) { subscribers.push(fn); };
  window.forstaCampaign.openCart = function () { openCart(false); };
  window.forstaCampaign.closeCart = closeDrawer;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
